"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var listViewBitFlagsUtil_1 = require("owa-bit-flags/lib/utils/listViewBitFlagsUtil");
function isSenderImageEnabled() {
    return !listViewBitFlagsUtil_1.getIsBitSet(8 /* HideSenderImage */);
}
exports.default = isSenderImageEnabled;
//# sourceMappingURL=isSenderImageEnabled.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-sender-image-option/lib/utils/isSenderImageEnabled.js
// module id = 5105
// module chunks = 2